import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isBulkActionsRedesignEnabled"];
import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, getSelectedRowIds, selectQuery } from '../redux/selectionSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BulkActionsContainerOld({
  BulkActionsComponent,
  totalRowCount
}) {
  const selectedRowIds = useTableSelector(getSelectedRowIds);
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const dispatch = useTableDispatch();
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  const count = isQuerySelected ? totalRowCount : selectedRowIds.size;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "bulk-actions-container",
    flexGrow: "1",
    paddingInline: "200",
    children: [/*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.bulkActions.selectionCount",
        options: {
          count
        }
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      display: "inline-block",
      space: "200"
    }), /*#__PURE__*/_jsx(BulkActionsComponent, {
      selection: selectedRowIds,
      querySelected: isQuerySelected,
      clearSelection: clearAllSelections
    })]
  });
}
function BulkActionsContainerNew({
  paddingBlockEnd,
  BulkActionsComponent,
  isIndexRedesignEnabled,
  showSelectQuery,
  totalRowCount
}) {
  const selectedRowIds = useTableSelector(getSelectedRowIds);
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const dispatch = useTableDispatch();
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  const selectEverything = useCallback(() => dispatch(selectQuery()), [dispatch]);
  const count = isQuerySelected ? totalRowCount : selectedRowIds.size;
  return /*#__PURE__*/_jsx(BulkActionsComponent, {
    paddingBlockEnd: paddingBlockEnd,
    clearSelection: clearAllSelections,
    doNotUseIsBorderless: !isIndexRedesignEnabled,
    isBulkActionsRedesignEnabled: true,
    onClose: clearAllSelections,
    onSelectQuery: selectEverything,
    querySelected: isQuerySelected,
    selection: selectedRowIds,
    selectionCount: count,
    showSelectQuery: showSelectQuery,
    totalCount: totalRowCount
  });
}
function BulkActionsContainer(_ref) {
  let {
      isBulkActionsRedesignEnabled = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (isBulkActionsRedesignEnabled) {
    return /*#__PURE__*/_jsx(BulkActionsContainerNew, Object.assign({}, rest));
  }
  return /*#__PURE__*/_jsx(BulkActionsContainerOld, Object.assign({}, rest));
}
export default BulkActionsContainer;